export const UserOrganizationMembershipWithUserFragment = gql`
  fragment UserOrganizationMembershipWithUserFragment on UserOrganizationMembership {
    id
    canViewForeignValues
    createdAt
    group
    hasCodeV1Access
    isAIStaffMember
    isCodeViolationsEmployeeReference
    isInspector
    isLandingPageEmployeeReference
    isPermittingEmployeeReference
    isPlanReviewer
    recordTypeAccesses {
      id
      recordType {
        id
        name
      }
    }
    roles
    title
    user {
      ...UserDataFragmentWithRecordTypeAccesses
    }
  }
`
